import { Affix, Card, DatePicker, Form, Input, Select, SelectProps, Spin } from 'antd'
import balance from 'assets/images/balance.png'
import image15 from 'assets/images/image15.png'
import image6 from 'assets/images/image6.png'
import image96 from 'assets/images/image96.png'
import BoxContainer from 'base/ui/components/BoxContainer'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
import PageWrapper from 'pages/Components/PageWrapper'
import { SearchForm, SearchItem } from 'pages/Components/SearchBox'
import { useCallback, useEffect, useState } from 'react'
import { CommonModel, createCommonServices } from 'services/Main/common_services'
import { IPurchaseOrderServices, KanbanRequest, KanbanResponse } from 'services/Main/purchaseOrder_services'
import { stockPresenter, stockStore } from 'stores/root_store'
import { SYSTEM_TITLE } from 'utils/constants'
import { debounce } from 'utils/debounce'
import { getRole, getUserName } from 'utils/localStorageHelper'
import { saveSearchParams, getSearchParams } from 'utils/searchParamsHelper'
import { CardItem } from './cardItem'
import CustomButton from 'base/ui/components/Button';

// kanbanCode: 'KanbanMR' kanban new
// màn hình Theo dõi giao/ nhận hàng
const createReceiveSchedule = (services: IPurchaseOrderServices) => {
  return observer(() => {
    document.title = 'Lịch nhận hàng - ' + SYSTEM_TITLE;

    const commonServices = createCommonServices();
    const [formSearch] = Form.useForm()
    const [kanbanData, setKanbanData] = useState<KanbanResponse | null>(null)
    const [loadingSekeleton, setLoadingSekeleton] = useState(true)
    const [loading, setLoading] = useState(false)
    const [listVendor, setListVendor] = useState<any[]>([])
    // Dropdown kho nhận
    const [listStocks, setListStocks] = useState<SelectProps['options']>([])
    // Dropdown kho nhận
    const [listProducts, setListProducts] = useState<any[]>([])

    // sau khi render lần đầu thì set = true
    const [isReady, setIsReady] = useState(false)

    const getReceiveSchedule = async (values: any) => {
      try {
        setLoading(true)
        const request: KanbanRequest = {
          kanbanCode: 'KanbanMR',
          searchDate: dayjs(values.searchDate).format('YYYY-MM-DD'),
          vendorNumber: ['NCC', 'NCC_CT'].includes(getRole()) ? getUserName() : values.vendorNumber,
          licensePlate: values.licensePlate ? values.licensePlate.trim() : undefined,
          stockCodes: values.stockCodes,
          productCodes: values.productCodes,
          type: values.type,
        }
        const result = await services.getKanban(request)
        setLoading(false)
        if (result && result.data) {
          setKanbanData(result.data)
        }
      } catch (error) {
        setLoading(false)
      }
    }
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
      const handleFullscreenChange = () => {
        setIsFullscreen(
          document.fullscreenElement !== null
        );
      };
      document.addEventListener('fullscreenchange', handleFullscreenChange);
      return () => {
        document.removeEventListener('fullscreenchange', handleFullscreenChange);
      }
    }, []);

    // Danh sách kho
    const getDropdownStock = async (keyword?: string) => {
      await stockPresenter.searchAllStock(stockStore, keyword || '')
      if (stockStore.searchAllStockResponse.isSuccess) {
        const stocks = stockStore.searchAllStockResponse.data
        setListStocks(stocks.map(stock => ({ label: stock.value, value: stock.stockCode })))
      }
    }
    // Danh sách hàng hóa
    const getDropdownProduct = async () => {
      const res = await commonServices.getDropdownProductAll()
      if (res && res.isSuccess && res.data) {
        console.log('resssssss', res?.data);
        const filtered = res.data?.map(item => {
          return { label: item.value, value: item.key }
        })
        setListProducts(filtered)
      }
    }

    // Dropdown nhà cung cấp - ban đầu load 20 items đầu từ listVendorAll
    const getDropdownVendor = async (dataInit?: { label: string, value: string }) => {
      const res = await commonServices.listVendorAll()
      if (res && res.isSuccess && res.data) {
        // Chỉ lấy 20 items đầu
        const filtered = res.data?.map(item => {
          return { label: item.value, value: item.key }
        })
        if (dataInit) {
          filtered.unshift(dataInit)
        }
        // loại bỏ trùng nhau (trường hợp dataInit đã tồn tại trong list)
        const uniqueVendors = Array.from(new Set(filtered.map(v => v.value))).map(value => {
          return filtered.find(v => v.value === value)
        })
        console.log('vendor', uniqueVendors);

        setListVendor(uniqueVendors.slice(0, 10))
      }
    }
    // Khi search thì gọi listVendorAll và filter theo keyword
    const searchVendor = useCallback(debounce(async (keyword?: string) => {
      const res = await commonServices.listVendorAll(keyword)
      if (res && res.isSuccess && res.data) {
        if (keyword) {
          // Filter theo keyword trên client
          const filtered = res.data.filter((item: CommonModel) =>
            (item.value || '').toLowerCase().includes(keyword.toLowerCase())
          ).slice(0, 10) // Giới hạn 10 kết quả
          const mapped = filtered?.map((item: CommonModel) => {
            return { label: item.value, value: item.key }
          })
          setListVendor(mapped)
        } else {
          const filtered = res.data?.map(item => {
            return { label: item.value, value: item.key }
          })
          // Nếu không có keyword thì chỉ lấy 20 items đầu
          setListVendor(filtered.slice(0, 10))
        }
      }
    }, 300), [])

    const searchProduct = useCallback(debounce(async (keyword?: string) => {
      const res = await commonServices.getDropdownProductAll(keyword)
      if (res && res.isSuccess && res.data) {
        if (keyword) {
          // Filter theo keyword trên client
          const filtered = res.data.filter((item: CommonModel) =>
            (item.value || '').toLowerCase().includes(keyword.toLowerCase())
          )
          const mapped = filtered?.map((item: CommonModel) => {
            return { label: item.value, value: item.key }
          })
          setListProducts(mapped)
        } else {
          const filtered = res.data?.map(item => {
            return { label: item.value, value: item.key }
          })
          // Nếu không có keyword thì chỉ lấy 20 items đầu
          setListProducts(filtered)
        }
      }
    }, 300), [])


    useEffect(() => {
      (async () => {

        // Kiểm tra xem có saved search params không
        const savedParams = getSearchParams('receiveSchedule');

        console.log('saveData👉👉👉👉👉👉👉👉👉👉👉', savedParams);


        await Promise.allSettled([
          getDropdownVendor(savedParams?.vendorName && savedParams?.vendorNumber ? {
            label: savedParams?.vendorName,
            value: savedParams?.vendorNumber,
          } : undefined),
          getDropdownStock(),
          getDropdownProduct(),
        ])
        if (savedParams || (['NCC', 'NCC_CT'].includes(getRole()) && getUserName())) {
          // Nếu có saved params, load lại trạng thái search trước đó
          console.log('Loading saved search params:', savedParams);

          let paramsToUse = { ...(savedParams ?? {}) };

          // Mỗi lần vào màn hình luôn tìm theo ngày hiện tại,
          // nhưng vẫn giữ các bộ lọc đã lưu khác.
          const todayStr = dayjs().format('YYYY-MM-DD');
          paramsToUse = {
            ...paramsToUse,
            searchDate: todayStr,
          };
          saveSearchParams('receiveSchedule', { ...paramsToUse });

          // Convert string date back to dayjs để hiển thị trong form
          const paramsWithDate = {
            ...paramsToUse,
            ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
            searchDate: dayjs(paramsToUse.searchDate),
          };

          // Set form values từ params đã cập nhật
          formSearch.setFieldsValue(paramsWithDate);

          // Load data với params đã cập nhật
          await getReceiveSchedule(paramsWithDate);
        } else {
          // Nếu không có saved params, load data với giá trị mặc định
          const defaultParams = {
            searchDate: dayjs().format("YYYY-MM-DD"),
            ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
          };
          await getReceiveSchedule(defaultParams);

          // Lưu params mặc định
          saveSearchParams('receiveSchedule', {
            searchDate: dayjs(),
            ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
          });
        }

        setIsReady(true)
        setLoadingSekeleton(false)
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      let timeoutId: NodeJS.Timer;
      if (isReady) {
        timeoutId = setInterval(() => {
          formSearch.submit()
        }, 60 * 1000)
      }
      return () => {
        clearInterval(timeoutId)
      }
    }, [isReady, formSearch]);


    return (
      <PageWrapper
        breadcrumb={[{
          text: "Theo dõi giao/ nhận hàng"
        }]}
        extras={
          <CustomButton
            className='w-[100px]'
            onClick={() => {
              formSearch.resetFields();
              const defaultParams = {
                searchDate: dayjs(),
                ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
              };
              formSearch.setFieldsValue(defaultParams);
              getReceiveSchedule(defaultParams);
              saveSearchParams('receiveSchedule', defaultParams)
            }}
          >
            {'Reset tìm kiếm'}
          </CustomButton>
        }
      >
        <BoxContainer id={'screen'} fullHeight className='!gap-2 overflow-auto' >
          <SearchForm
            // className={isFullscreen ? '!hidden' : ''}
            layout='vertical'
            column='col-5'
            colon={false}
            className='[&_.ant-form-item]:!mb-0'
            style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '16px' }}
            initialValues={{
              searchDate: dayjs(),
              ...((['NCC', 'NCC_CT'].includes(getRole())) && { vendorNumber: getUserName() }),
            }}
            form={formSearch}
            onFinish={(values) => {
              // Lưu search params vào localStorage
              saveSearchParams('receiveSchedule', values)

              getReceiveSchedule(values)
            }}

          >
            <button type='submit' hidden></button>
            {/* Ngày giao hàng */}
            <SearchItem name={'searchDate'} label="Ngày giao hàng">
              <DatePicker className='w-full' allowClear={false} format={'DD/MM/YYYY'}
                changeOnBlur
                onSelect={(value) => {
                  formSearch.submit()
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    formSearch.submit()
                  }
                }}
              />
            </SearchItem>
            {/* Nhà cung cấp */}
            <SearchItem name={'vendorNumber'} label="Nhà cung cấp">
              <Select
                allowClear
                options={listVendor}
                // fieldNames={{ label: "value", value: 'key' }}
                disabled={getRole() === 'NCC' || getRole() === 'NCC_CT'}
                popupMatchSelectWidth={false}
                showSearch
                filterOption={false}
                onSearch={searchVendor}
                onSelect={(value, opt) => {
                  formSearch.submit()
                  formSearch.setFieldValue('vendorName', opt.label) // Set tên nhà cung cấp vào field ẩn
                }}
                // onFocus={() => {
                //   searchVendor()
                // }}
                onClear={() => {
                  formSearch.submit()
                  formSearch.setFieldValue('vendorName', "") // Set tên nhà cung cấp vào field ẩn

                }}
                placeholder="Vui lòng chọn"
              />
            </SearchItem>

            {/* field ngầm, tên nhà cung cấp */}
            <SearchItem hidden name={'vendorName'} label=" ">
              <Input hidden />
            </SearchItem>

            {/* Kho */}
            <SearchItem name={'stockCodes'} label="Kho/ Khu vực">
              <Select
                allowClear
                showSearch
                mode='multiple'
                options={listStocks}
                filterOption={(input, option) => (option?.value + '' || '')?.toLowerCase()?.includes(input.toLowerCase())}
                // onSelect={(value) => {
                //   formSearch.submit()
                // }}
                onBlur={() => {
                  formSearch.submit()
                }}
                onDeselect={() => {
                  formSearch.submit()
                }}
                onClear={() => {
                  formSearch.submit()
                }}
                placeholder="Vui lòng chọn"
              />
            </SearchItem>
            {/* Hàng hóa */}
            <SearchItem name={'productCodes'} label="Hàng hóa/ Chất thải">
              <Select
                mode='multiple'
                allowClear
                options={listProducts}
                disabled={getRole() === 'NCC' || getRole() === 'NCC_CT'}
                filterOption={false}
                popupMatchSelectWidth={false}
                onSearch={searchProduct}
                showSearch
                onBlur={() => {
                  formSearch.submit()
                }}
                onDeselect={() => {
                  formSearch.submit()
                }}
                onClear={() => {
                  formSearch.submit()
                }}
                onFocus={() => {
                  // Khi focus thì load lại 20 items đầu
                  getDropdownProduct()
                }}
                placeholder="Vui lòng chọn"
              />
            </SearchItem>
            {/* Loại phiếu */}
            <SearchItem name={'type'} label="Loại phiếu">
              <Select
                allowClear
                placeholder="Vui lòng chọn"
                onBlur={() => {
                  formSearch.submit()
                }}
                onSelect={(value) => {
                  formSearch.submit()
                }}
                onClear={() => {
                  formSearch.submit()
                }}
              >
                <Select.Option value="WasteMaterial">Chất thải/Phế liệu</Select.Option>
                <Select.Option value="AVN_WF">Nguyên vật liệu</Select.Option>
              </Select>
            </SearchItem>
            {/* Số xe */}
            <SearchItem name={'licensePlate'} label="Số xe">
              <Input onBlur={() => {
                formSearch.submit()
              }}
                placeholder="Nhập số xe"
              />
            </SearchItem>
          </SearchForm>

          <div className="h-full" >
            <Spin spinning={!loadingSekeleton && loading} rootClassName='h-full' className='h-full' >
              <div className='w-full h-full' >
                <Affix offsetTop={0} className='w-full'>
                  <div className={`px-2 mb-2 z-10 bg-white`} style={{ boxShadow: '0 10px 7px -5px #dbdbdb' }}>
                    <div className={`grid gap-1.5 text-sm font-bold py-1`} style={{ gridTemplateColumns: `repeat(${kanbanData?.columns.length || 6}, 1fr)` }}>
                      {kanbanData?.columns.map((column, index) => {
                        // Map mobileImage to image
                        const getColumnIcon = () => {
                          switch (column.mobileImage) {
                            case 'DELIVERY_TRUCK':
                              return <img src={image6} className='w-10' />;
                            case 'SCALE':
                              // return <img src={image14} className='w-8' />;
                              return <img src={balance} className='w-8' />;
                            case 'BOX':
                              return <img src={image96} className='w-8' />;
                            case 'OUT_TRUCK':
                              return <img src={image15} className='w-10' />;
                            default:
                              return <img src={image6} className='w-10' />;
                          }
                        };
                        return (
                          <div key={index} className='w-full flex items-center gap-2 justify-center'>
                            {getColumnIcon()}
                            <h2>{column.text}</h2>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Affix>

                <div className={`grid gap-1.5 text-xs`} style={{ gridTemplateColumns: `repeat(${kanbanData?.columns.length || 6}, 1fr)`, minHeight: isFullscreen ? 'calc(100vh - 128px)' : undefined }}>
                  {loadingSekeleton && kanbanData?.columns.map((column, index) => (
                    <div key={index} className="flex flex-col gap-1.5 bg-gray-100 p-1 h-full" style={{ minHeight: 'calc(100vh - 280px)' }}>
                      {[1, 2, 3].map((idx) => (
                        <Card className='!z-0' key={idx} size='small' loading></Card>
                      ))}
                    </div>
                  ))}
                  {!loadingSekeleton && kanbanData?.columns.map((column, columnIndex) => {
                    // Lọc items theo state (dataField)
                    const columnItems = kanbanData.kanbanDetailList.filter(item => item.state === column.dataField);

                    // Xác định màu và ẩn/hiện checkInOut dựa trên state
                    const getColumnConfig = (state: string) => {
                      switch (state) {
                        case '10': // Dự kiến xe vào nhà máy
                          return { color: '#ffffff', hideCheckInOut: true };
                        case '20': // Chờ cân đầu vào
                          return { color: '#ffe699', hideCheckInOut: false };
                        case '30': // Chờ giao/nhận hàng
                          return { color: '#D7DAE4', hideCheckInOut: false };
                        case '40': // Chờ cân đầu ra
                          return { color: '#D7DAE4', hideCheckInOut: false };
                        case '50': // Chờ ra cổng
                          return { color: '#c6e0b4', hideCheckInOut: false };
                        case '60': // Đã ra cổng
                          return { color: '#c6e0b4', hideCheckInOut: false };
                        default:
                          return { color: '#ffffff', hideCheckInOut: true };
                      }
                    };

                    const config = getColumnConfig(column.dataField);

                    return (
                      <div key={columnIndex} className="flex flex-col gap-1.5 bg-gray-100 p-1 h-full" style={{ minHeight: 'calc(100vh - 280px)' }}>
                        {columnItems.map((item, itemIndex) => (
                          <CardItem
                            key={itemIndex}
                            data={{
                              id: item.taskId,
                              title: item.title,
                              expectedDate: item.deliveryTime,
                              driverName: item.driverName,
                              licensePlate: item.licensePlate,
                              vendor: item.vendorName,
                              checkIn: item.checkInDate || undefined,
                              checkOut: item.checkOutDate || undefined,
                              reason: item.rejectReason || undefined,
                              isCreateBySystem: item.isCreateBySystem,
                              workflowCode: item.workflowCode,
                              productCode: item.productCode,
                              productName: item.productName,
                              kanbanIcon: item.kanbanIcon,
                            }}
                            icon={null}
                            hidenCheckInOut={config.hideCheckInOut}
                            hidenReason={column.dataField !== '30'} // Chỉ hiển thị lý do từ chối ở cột "Từ chối nhận hàng"
                            color={config.color}
                          />
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Spin>
          </div>
        </BoxContainer>

      </PageWrapper>
    )
  })
}



export default createReceiveSchedule
